import { getCssVar } from "../../types/theme.ts";

export const ApprovedIcon = () => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="approve 1">
      <path
        id="Vector"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.25614 1.66192C8.49734 1.47337 8.836 1.47337 9.0772 1.66192L10.1834 2.52656L11.5737 2.33086C11.8769 2.28819 12.1702 2.45751 12.2849 2.74142L12.8105 4.04332L14.1124 4.569C14.3963 4.68364 14.5657 4.97691 14.523 5.2801L14.3273 6.67042L15.1919 7.77664C15.3805 8.01784 15.3805 8.35651 15.1919 8.59771L14.3273 9.70391L14.523 11.0942C14.5657 11.3974 14.3963 11.6907 14.1124 11.8054L12.8105 12.331L12.2849 13.6329C12.1702 13.9168 11.8769 14.0862 11.5737 14.0435L10.1834 13.8478L9.0772 14.7124C8.836 14.901 8.49734 14.901 8.25614 14.7124L7.14991 13.8478L5.75959 14.0435C5.4564 14.0862 5.16313 13.9168 5.0485 13.6329L4.52281 12.331L3.22091 11.8054C2.937 11.6907 2.76768 11.3974 2.81035 11.0942L3.00605 9.70391L2.14141 8.59771C1.95286 8.35651 1.95286 8.01784 2.14141 7.77664L3.00605 6.67042L2.81035 5.2801C2.76768 4.97691 2.937 4.68364 3.22091 4.569L4.52281 4.04332L5.0485 2.74142C5.16313 2.45751 5.4564 2.28819 5.75959 2.33086L7.14991 2.52656L8.25614 1.66192ZM11.1381 7.32524C11.3984 7.06491 11.3984 6.64279 11.1381 6.38244C10.8777 6.12209 10.4556 6.12209 10.1953 6.38244L8 8.57771L7.13808 7.71578C6.87772 7.45544 6.45561 7.45544 6.19526 7.71578C5.93491 7.97611 5.93491 8.39824 6.19526 8.65858L7.5286 9.99191C7.78894 10.2522 8.21107 10.2522 8.4714 9.99191L11.1381 7.32524Z"
        fill={getCssVar("color_accent_3")}
      />
    </g>
  </svg>
);
